import { useMemo } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useUserFlows } from "hooks/useUserFlows";

export const useDetermineShareFlowUserAccessType = (flow_id) => {
  const { user } = useAuth0();
  const { userFlows } = useUserFlows();

  const accessType = useMemo(() => {
    if (!flow_id || !user) {
      return {
        isReadOnlyAccess: false,
        isEditor: false,
        accessType: null
      };
    }

    const userFlow = userFlows?.find(
      (userFlow) => userFlow.flow_id === flow_id && userFlow.user_id === user?.cxfUserId
    );

    const type = userFlow?.access_type;

    return {
      isReadOnlyAccess: type === "readOnly",
      isEditor: type === "editor",
      accessType: type
    };
  }, [flow_id, user, userFlows]);

  return accessType;
};
